import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ModalCloseStrategy, SdModalOptions } from '@shared/v2';
import { SdvorClickOutsideDirective } from '../../../../directives';
import { SdvorIconComponent } from '../../../icon';

@Component({
  selector: 'sd-modal-fullscreen',
  templateUrl: './modal-fullscreen.component.html',
  styleUrls: ['./modal-fullscreen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdvorIconComponent, SdvorClickOutsideDirective],
})
export class SdvorModalFullscreenComponent {
  options = input.required<SdModalOptions>();
  closed = output<void>();

  onClose(): void {
    this.closed.emit();
  }

  onClickOutside(): void {
    if (this.options().closeStrategy !== ModalCloseStrategy.Outside || this.options().ignoreOutsideClick) {
      return;
    }

    this.onClose();
  }
}
